import React, { Component } from "react";
import { View, StyleSheet, Text } from "react-native";

import * as x from "../../styles/css";


class StyledText extends Component {
	render() {
		return (
			<Text numberOfLines={this.props.numberOfLines} style={[this.props.help ? x.fonts.help : x.fonts.text, this.props.style]}>
                {this.props.children}
            </Text>
		);
	}
}

const styles = StyleSheet.create({
	title: {
		color: "white",
		fontSize: 18,
		fontWeight: "300",
	},
	button: {
		height: 60,
	},
});

export default StyledText;



// WEBPACK FOOTER //
// ./src/components/StyledText/index.web.js